﻿import Vue from "vue";
import common from "../../common";
import context_ from "../context";
import core from "../../core";
import EditVue_ from "../vue/EditVue";
import HotEditableFormAction_ from "../vue/hotEditable/HotEditableFormAction";
import utilities_ from "../utilities";
import DefaultTransfertSearchBoxes_ from "./DefaultTransfertSearchBoxes";

declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const utilities = require("../utilities") as typeof utilities_;
// const EditVue = require("../vue/EditVue") as EditVue_;
// const HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction") as HotEditableFormAction_;
// const DefaultTransfertSearchBoxes = require("./DefaultTransfertSearchBoxes") as DefaultTransfertSearchBoxes_;

interface ISettings {
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId_top: string;
    vueElId_bottom: string;
    /** URL correspondant a la page precedente (doit etre definie si l'option "useBrowserHistoryToGoBackOnCancel" est activee) */
    previousPageUrl?: string;
    /** Definie si le clique du bouton Annuler ("cancel") doit faire un "Back history" ou s'il doit aller a l'API (default: true) */
    useBrowserHistoryToGoBackOnCancel?: boolean;
    filterByFederationRegionaleId?: boolean;
    /** settings du DefaultTransfertSearchBoxesSettings */
    transfertSearchBoxesSettings?: any;
}

class AssocierDesMunicipalitesAuSyndicatSpecialise implements common.IWebComponent {
    private _isEditionAlwaysOn = false;
    private _isInit = false;
    private _editVue_top = null as EditVue_ | null;
    private _editVue_bottom = null as EditVue_ | null;
    private _loader = null as core.Loader | null;
    private _previousPageUrl?: string | null;
    private _vueElId_top?: string | null;
    private _vueElId_bottom?: string | null;
    private _useBrowserHistoryToGoBackOnCancel?: boolean;
    private _transfertSearchBoxes?: DefaultTransfertSearchBoxes_ | null;

    // Initialisation
    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._vueElId_top = s.vueElId_top || null;
        this._vueElId_bottom = s.vueElId_bottom || (() => { throw "La propriété 'settings.vueElId_bottom' est requise."; })();
        this._useBrowserHistoryToGoBackOnCancel = s.useBrowserHistoryToGoBackOnCancel !== false;//default is TRUE
        this._previousPageUrl = s.previousPageUrl || null;

        //this._loader = new core.Loader(this._vueElId_top);

        this._transfertSearchBoxes = s.transfertSearchBoxesSettings
            ? new DefaultTransfertSearchBoxes_().init(s.transfertSearchBoxesSettings) as DefaultTransfertSearchBoxes_
            : null;

        this.setupVues(s);

        return context.components.add(this);
    }

    private setupVues(s: ISettings) {
        if (this._vueElId_top) {
            // TOP
            Vue.prototype.$initialData = {
                vueElId: this._vueElId_top
            };
            this._editVue_top = new EditVue_();//.setManageButtonsOnFormModeChange(false);
            this._editVue_top?.shared?.setActionCallback((a: HotEditableFormAction_) => {
                this.onFormAction(a);
            });
            this._editVue_top?.shared?.setupForm(this._isEditionAlwaysOn);
        }

        // BOTTOM
        Vue.prototype.$initialData = {
            vueElId: this._vueElId_bottom
        };
        this._editVue_bottom = new EditVue_().setManageButtonsOnFormModeChange(false);
        this._editVue_bottom?.shared?.setActionCallback((a: HotEditableFormAction_) => {
            this.onFormAction(a);
        });
        this._editVue_bottom?.shared?.setupForm(this._isEditionAlwaysOn);
    }
    private onFormAction(action: HotEditableFormAction_) {

        const actionType = action.getActionType();

        if (action.getFieldName() === 'FilterByFederationRegionaleId' && actionType === common.HotEditableActionTypes.unknown) {
            this.onFilterByFederationRegionaleIdUpdated(action.getFieldTextualValue())
            return;
        }

        if (actionType === common.HotEditableActionTypes.cancel && this._useBrowserHistoryToGoBackOnCancel) {
            utilities.redirect(this._previousPageUrl);
            return;
        }
    }

    private onFilterByFederationRegionaleIdUpdated(id?: string | null) {
        const k = 'federationRegionaleId';
        const url = utilities.updateUrlParameter(utilities.currentUrl(), k, id);
        utilities.updateBrowserUrl(url, true);
        setTimeout(() => {
            if (this._transfertSearchBoxes) {
                // left
                this._transfertSearchBoxes.searchBoxLeft?.refresh();
                if (this._transfertSearchBoxes.searchBoxLeft?.customData)
                    (this._transfertSearchBoxes.searchBoxLeft.customData as any)['guidValues'][k] = id;
                // right
                if (this._transfertSearchBoxes.searchBoxRight?.customData)
                    (this._transfertSearchBoxes.searchBoxRight.customData as any)['guidValues'][k] = id;
                this._transfertSearchBoxes.searchBoxRight?.refresh();
            }
        }, 1);
    }
}

export = AssocierDesMunicipalitesAuSyndicatSpecialise;